<template>
    <section class="container">
        <h2 class="title is-2">F5</h2>
        <p class="subtitle is-5">Just press f5 and get some nice looking art</p>


        <iframe src="//projects.panduro.guru/f5/" frameborder="0" class="canvas-container"></iframe>
    </section>
</template>

<script>
export default {
    name: "f5",
};
</script>

<style lang="scss" scoped>
.canvas-container {
    width: 850px;
    height: 650px;


}

iframe {
    margin: 0px auto;
    display: block;
}
</style>
